<template>
  <div class="home">
    <app-sidebar></app-sidebar>

    <!-- Shop by category section -->
    <div class="wrapper-content">
      <app-header></app-header>

      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Delivery Address List</h2>
        </div>
      </div>

      <div class="addmoney">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="deliver-address-list panel">
                <div class="subcription-list">
                  <div class="subsribe-list">
                    <h4>
                      home
                      <a href="#">default</a>
                    </h4>
                    <p>Site 1 & 2, Sector 69, Near Gurudwara Singh Shaheedan, Sector 69, Sahibzada Ajit Singh Nagar, Punjab 160062</p>
                  </div>
                  <div class="active-block">
                    <ul>
                      <li>
                        <a href="#">
                          <img class="svg" src="../assets/images/edit.svg" alt="edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img class="svg" src="../assets/images/close.svg" alt="close" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="subcription-list">
                  <div class="subsribe-list">
                    <h4>Work</h4>
                    <p>Site 1 & 2, Sector 69, Near Gurudwara Singh Shaheedan, Sector 69, Sahibzada Ajit Singh Nagar, Punjab 160062</p>
                  </div>
                  <div class="active-block">
                    <ul>
                      <li>
                        <a href="#">
                          <img class="svg" src="../assets/images/edit.svg" alt="edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img class="svg" src="../assets/images/close.svg" alt="close" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button class="submit-btn">submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="parentSidebar" id="parentx">
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default {
  name: "home",
  components: {
    "app-header": Header,
    "app-sidebar": Sidebar,
    "app-footer": Footer
    // HelloWorld
  }
};
</script>
